import { render, staticRenderFns } from "./GroupHeader.vue?vue&type=template&id=3d3f9c10&"
import script from "./GroupHeader.vue?vue&type=script&lang=ts&"
export * from "./GroupHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports